"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SportIcon = SportIcon;
var _SvgIcon2 = _interopRequireDefault(require("@mui/material/SvgIcon"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function SportIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_SvgIcon2.default, _extends({
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    d: "M16.604 11.0955H21C20.8553 9.63925 20.3578 8.28246 19.607 7.11562C18.0422 7.86638 16.9025 9.33171 16.604 11.0955Z",
    fill: "currentColor"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M7.39597 11.0956C7.09748 9.33173 5.95779 7.86639 4.39296 7.11563C3.64221 8.28247 3.14472 9.63927 3 11.0956H7.39597Z",
    fill: "currentColor"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.7769 11.0955C15.0663 8.7528 16.4774 6.76284 18.4492 5.66836C17.002 4.19398 15.0663 3.21709 12.9045 3V11.0955H14.7769Z",
    fill: "currentColor"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M9.22316 11.0955H11.0955V3C8.93371 3.21709 6.98899 4.19398 5.5508 5.66836C7.52266 6.76284 8.93371 8.7528 9.22316 11.0955Z",
    fill: "currentColor"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.7769 12.9045H12.9045V21C15.0663 20.7829 17.011 19.806 18.4492 18.3316C16.4774 17.2372 15.0663 15.2472 14.7769 12.9045Z",
    fill: "currentColor"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M4.39296 16.8844C5.94874 16.1337 7.09748 14.6593 7.39597 12.9045H3C3.14472 14.3608 3.64221 15.7176 4.39296 16.8844Z",
    fill: "currentColor"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M16.604 12.9045C16.9025 14.6683 18.0422 16.1336 19.607 16.8844C20.3578 15.7175 20.8553 14.3608 21 12.9045H16.604Z",
    fill: "currentColor"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M9.22316 12.9045C8.93371 15.2472 7.52266 17.2372 5.5508 18.3316C6.99804 19.806 8.93371 20.7829 11.0955 21V12.9045H9.22316Z",
    fill: "currentColor"
  }));
}